export default __webpack_public_path__ + "a7cf8c9fd11e0d388fd824830915fe97.png";